<template>
  <node-view-wrapper class="inline" data-drag-handle>
    <span ref="container" draggable="true" class="inline-block h-[30px]">
      <a-tooltip
        placement="top"
        :visible="hover && !active"
        :title="getTagKey(props.node.attrs.key)?.label ?? '未知数据源'"
        :get-popup-container="() => container"
      >
        <span
          class="inline-block h-[30px]"
          :class="{
            selected:
              props.selected ||
              (getPos() >= editor.state.selection.from &&
                getPos() < editor.state.selection.to)
          }"
        >
          <span
            class="tag"
            :class="{
              'tag-selected':
                props.selected ||
                (getPos() >= editor.state.selection.from &&
                  getPos() < editor.state.selection.to)
            }"
            :style="{
              '--color': props.node?.marks[0]?.attrs['color'] ?? '#FFF'
            }"
            @mouseover="() => (hover = true)"
            @mouseleave="() => (hover = false)"
            @mousedown="() => (active = true)"
            @mouseup="() => (active = false)"
            @mousemove="(e) => !e.buttons && (active = false)"
            @click="handleClick"
          >
            {{ $props.node.attrs.renderingValue }}
          </span>
        </span>
      </a-tooltip>
    </span>
  </node-view-wrapper>
</template>

<script lang="ts" setup>
import { dataSourceList } from '@/resources/data-source';
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3';
import { computed, ref } from 'vue';
const props = defineProps(nodeViewProps);
const getTagKey = (key: string) =>
  Object.entries(dataSourceList)
    .map((i) => i[1])
    .flat()
    .find((i) => i.key === key);
const container = ref();
const hover = ref(false);
const active = ref(false);
// 点击左侧光标定位到node前, 点击右侧定位到node后
const handleClick = computed(
  () => (e: MouseEvent) =>
    props.editor.commands.setTextSelection(
      props.getPos() +
        (e.offsetX <=
        (e.target as HTMLElement).getBoundingClientRect().width / 2
          ? 0
          : 1)
    )
);
</script>
<style lang="less" scoped>
:deep(.tag) {
  margin: 0px 1px;
  padding: 0px 4px;
  border: 1px solid;
  border-color: #7b4634;
  background-color: rgba(174, 79, 48, 0.2);
  height: 24px;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: var(--color);
  cursor: default;
  transition-duration: 0.2s;
}
:deep(.tag-selected) {
  border-color: #ff541e;
}
:deep(.selected) {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
